import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './styles.module.scss';
import SilentPicker from '../SilentPicker/SilentPicker';

import { useCommentSlice } from '../CommentState';
import {
  selectSelectedSection,
  selectSectionOptions
} from '../CommentState/selectors';

function SectionDropdown() {
  const dispatch = useDispatch();
  const { actions } = useCommentSlice();

  // Get state from Redux
  const selectedSection = useSelector(selectSelectedSection);
  const sectionOptions = useSelector(selectSectionOptions);

  const selectedDropDownHandler = (
    key: string,
    item: any,
    sectionLabel?: string
  ) => {
    dispatch(actions.sectionChanged({ key, item, sectionLabel }));
  };

  return (
    <div className={styles.sectionDropdownContainer}>
      <label htmlFor="section-dropdown">Section:&nbsp;</label>
      <SilentPicker
        id="section-dropdown"
        items={sectionOptions}
        selectedKey={selectedSection ? selectedSection.key : ''}
        onSelectionChange={selectedDropDownHandler}
      />
    </div>
  );
}

export default SectionDropdown;
